export default __webpack_public_path__ + "static/Plots0014-8873d9d6d29c3d5005b3ede4ecb3b758.jpg";